import { Icon, Stack, Text, useTheme } from '@fluentui/react';
import { useCallback, useRef, forwardRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TSettingsCategory } from './Dashboard';
import { buildRoute } from '../../helpers/routeHelpers';

export const SettingsCard = forwardRef<HTMLDivElement, TSettingsCategory>(function SettingsCard({ iconName, link, title, shortDescription }, ref) {
    const theme = useTheme();
    const iconRef = useRef<HTMLDivElement>(null);
    const { pathname } = useLocation();
    const linkHandler = useNavigate();

    const handler = useCallback(
        (event: any) => {
            linkHandler(buildRoute(pathname, link));
        },
        [link, linkHandler, pathname],
    );

    return (
        <div
            ref={ref}
            style={{
                padding: 20,
                cursor: 'pointer',
                backgroundColor: theme.semanticColors.bodyBackground,
                borderRadius: 5,
            }}
            className="card"
            onClick={handler}
        >
            <Stack horizontalAlign="center" tokens={{ childrenGap: 10 }}>
                <Text styles={{ root: { color: 'inherit' } }} variant="xLarge">
                    {title}
                </Text>
                <Stack horizontalAlign="center">
                    <div ref={iconRef}>
                        <Icon
                            className="settings-icon"
                            iconName={iconName}
                            styles={{
                                root: {
                                    fontSize: '4rem',
                                    padding: '10px 0',
                                },
                            }}
                        />
                    </div>
                </Stack>
                <Text styles={{ root: { color: 'inherit', textAlign: 'center' } }} variant="large">
                    {shortDescription}
                </Text>
            </Stack>
        </div>
    );
});
